<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">ATUALIZAÇÕES CADASTRAIS</span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    idTabela="tblAtualizacoesCadastrais"
                    :itens="atualizacoesCadastraisFiltradas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12">
                                <b-form inline class="justify-content-end">
                                    <label class="mr-sm-2">Status</label>
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="statusLista"
                                        v-model="statusSelecionado"
                                    ></b-form-select>
                                </b-form>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="cpfCnpj" slot-scope="data">
                        <span v-if="data.cpfCnpj.length == 11">{{
                            data.cpfCnpj | toCpf
                        }}</span>
                        <span v-if="data.cpfCnpj.length == 14">{{
                            data.cpfCnpj | toCnpj
                        }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('GEST-DADOS-00')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="
                                    detalharAtualizacaoCadastral(
                                        data.atualizacaoCadastralId
                                    )
                                "
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import AtualizacoesCadastraisServicos from './AtualizacoesCadastraisServicos'

export default {
    data() {
        return {
            erros: [],
            atualizacoesCadastrais: [],
            atualizacoesCadastraisFiltradas: [],
            statusSelecionado: 0,
            statusLista: [
                { value: -1, text: 'TODAS' },
                { value: 0, text: 'EM APROVAÇÃO' },
                { value: 1, text: 'APROVADA' },
                { value: 2, text: 'REPROVADA' }
            ],
            campos: [
                {
                    key: 'dataSolicitacao',
                    label: 'Data da Solicitação',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'cpfCnpj',
                    label: 'CNPJ/CPF',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'razaoSocial',
                    label: 'Razão Social/Nome',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterAtualizacoesCadastrais() {
            this.$store.dispatch('addRequest')
            AtualizacoesCadastraisServicos.obterTodas().then(response => {
                if (response) {
                    if (response.success) {
                        this.atualizacoesCadastrais = response.data
                        this.aplicarFiltroStatus()
                    } else {
                        this.erros = [
                            'Erro ao obter as atualizações cadastrais'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        aplicarFiltroStatus() {
            if (this.statusSelecionado == -1) {
                this.atualizacoesCadastraisFiltradas = this.atualizacoesCadastrais
            } else {
                this.atualizacoesCadastraisFiltradas = this.atualizacoesCadastrais.filter(
                    item => {
                        return item.status == this.statusSelecionado
                    }
                )
            }
        },

        detalharAtualizacaoCadastral(atualizacaoCadastralId) {
            this.$router.push({
                name: 'GestaoAtualizacoesCadastrais_Detalhar',
                params: {
                    atualizacaoCadastralId
                }
            })
        }
    },

    created() {
        this.obterAtualizacoesCadastrais()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'GestaoAtualizacoesCadastrais'
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'GestaoAtualizacoesCadastrais') {
                if (this.$store.getters.recarregar) {
                    this.obterAtualizacoesCadastrais()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        statusSelecionado() {
            this.aplicarFiltroStatus()
        }
    },

    components: {}
}
</script>
